import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  devices: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "device",
  initialState,
  reducers: {
    getDeviceSuccess: (state, { payload }) => {
      state.devices = payload;
      state.loading = false;
    },
    startLoadingDevice: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllDevices = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
     
      dispatch(slice.actions.startLoadingDevice());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-devices`,
        { headers }
      );
      dispatch(slice.actions.getDeviceSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};


